import { DeviceMountEnum } from '@ubnt/link-core/enums';
import { throwOrLog } from 'utils/env';

export const resolveMountSwitchMount = (
  mount: ValuesOf<typeof DeviceMountEnum> | null | undefined,
  mountCapabilities: readonly ValuesOf<typeof DeviceMountEnum>[] | null | undefined
) => {
  if (!mount || mountCapabilities == null || mountCapabilities.length <= 1) {
    return null;
  }

  const supportsWallAndCeiling =
    mountCapabilities.includes(DeviceMountEnum.Ceiling) && mountCapabilities.includes(DeviceMountEnum.Wall);

  if (!supportsWallAndCeiling) {
    return null;
  }

  if (mount === DeviceMountEnum.Ceiling || mount === DeviceMountEnum.Wall) {
    return mount;
  }

  throwOrLog(`Unknown mount: ${mount}`);

  return null;
};
